import clsx from 'clsx'
import parse from 'html-react-parser'
import { useRouter } from 'next/router'
import { Section } from '@/components'
import { getTranslatedField } from '@/libs/utils'
import type { CreditTable } from '@/@types/microcms-type'

export const Credit = ({ credit_table }: { credit_table: CreditTable[] }) => {
    const locale = useRouter().locale
    return (
        <Section className="bg-v-white xl:justify-end xl:max-w-[70vw] mt-12 md:mt-32 xl:mr-[10vw]">
            <Section
                as="div"
                width="full"
                className={clsx(
                    'grid-cols-1 gap-16 md:gap-x-24 md:gap-y-28 [&_*]:!text-left [&_*]:text-v-xs',
                    'only-sm:[&_th]:block only-sm:[&_td]:block only-sm:[&_th]:pb-0 only-sm:last:[&_th]:pb-4 only-sm:[&_td]:py-[1px] only-sm:last:[&_td]:pb-6 [&_th_p]:leading-[1.5em] [&_td_p]:leading-[1.5em] md:[&_td_p]:py-[0.5em] [&_th_p]:text-[1.2rem] [&_th]:pb-4 [&_td]:pr-6 md:[&_td]:pr-10 last:[&_td]:pr-0 first:[&_td]:text-v-gray-dark/80 only-sm:first:[&_th]:w-full first:[&_th]:w-[240px] [&_td]:min-w-[100px] xl:[&_td]:min-w-[120px] [&_td]:align-top'
                )}
            >
                {credit_table.map((table, i) => {
                    if (
                        table.credit_ja !== undefined ||
                        table.credit_en !== undefined
                    ) {
                        const credit_html = getTranslatedField({
                            field: table,
                            locale
                        })

                        return (
                            <div key={`${table.fieldId}-${i}`}>
                                {parse(credit_html)}
                            </div>
                        )
                    }
                })}
            </Section>
        </Section>
    )
}
